import React from 'react';
import { Link } from 'react-router-dom';
import PageHeader from '@/components/ui/PageHeader';

export default function NotFound() {
  return (
    <div data-testid="page-not-found">
      <PageHeader
        eyebrow="404"
        title="This bottle"
        accent="hasn't been made yet."
        description="The page you're looking for is missing from our shelf. Let's get you back to something refreshing."
      />
      <div className="container-x pb-24">
        <Link to="/" className="btn-primary inline-flex">Take me home</Link>
      </div>
    </div>
  );
}
